import styled from "styled-components";

export const Main = styled.div<{ $isTextVisible?: boolean }>`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 436px;
  height: ${({ $isTextVisible }) => ($isTextVisible ? "210px" : "133px")};
  border-radius: 8px;
  padding-top: 5px;
  background-color: #fff;
  & div.loadingTextContent {
    color: #0033c6;
    transform: translateY(25px);
  }
  z-index: 99999;
`;

export const Overlay = styled.div`
  background: linear-gradient(
    180deg,
    rgba(187, 189, 191, 0.2) 0%,
    rgba(187, 189, 191, 0.52) 23.96%,
    rgba(187, 189, 191, 0.52) 52.08%,
    rgba(187, 189, 191, 0.52) 86.46%
  );
  backdrop-filter: blur(3px);
  width: 100%;
  height: 100%;
  z-index: 9999;
`;

export const SpinStyle = styled.span`
  .ant-spin-dot-item {
    background: #0033c6;
  }
`;
